export const getDocument = () =>
  'undefined' == typeof document ? void 0 : document;
export const getWindow = () => ('undefined' == typeof window ? void 0 : window);
export const mergeEventHandlers =
  (...callbacks) =>
  (event) => {
    for (let cb of callbacks) {
      cb?.(event);
      if (event?.defaultPrevented) return;
    }
  };
export const getTranslateValuesFromElement = (element) => {
  if (!element) return [];
  let transformValue = getComputedStyle(element).getPropertyValue('transform');
  return getTranslateValues(transformValue);
};
export const getTranslateValues = (transformValue) => {
  let matrix = new DOMMatrix(transformValue);
  return [matrix.m41, matrix.m42];
};
